// FIXME: JQuery依存コードをなくしたい
import $ from 'jquery';

function toast_menu() {
  $('.toast-menu').css({
    'bottom': '20px'
  });

  setTimeout(function() {
    $('.toast-menu').css({
      'bottom': ''
    });
  }, 5000);
}

$(function() {
  $(document).on('click', function (e) {
    var showList = null;
    if ($(e.target).closest('.open-list').length) {
      showList = $(e.target).closest('.open-list').nextAll('.list');
    } else if ($(e.target).closest('.list').length) {
      showList = $(e.target).closest('.list');
    }
    $('.list').not(showList).hide();
  });

  $('.open-list').on('click', function() {
    var list = $(this).nextAll('.list').first();
    if(list.is(':visible')) {
      list.hide();
    } else {
      list.show();
    }
  });

  const sidebarControl = document.getElementById('sidebar-control');
  if (sidebarControl) {
    sidebarControl.addEventListener('click', () => {
      const sidemenuCollapseStatus = document.body.classList.toggle('sidemenu-collapse');

      // サイドメニュー折りたたみ状況をcookieに保存（有効期間1年）
      document.cookie = `sidemenu-collapse-status=${sidemenuCollapseStatus}; path=/; max-age=${60 * 60 * 24 * 365}`
    });
  }
  $(document).on('touchstart', function (e) {
    // 幅が1018px以下のビューポートをターゲットとするメディアクエリを作成
    const mediaQuery = window.matchMedia('(max-width: 1018px)')
    // メディアクエリがtrueかどうかをチェック
    if (mediaQuery.matches) {
      // サイドメニュー折りたたみ状況を閉じた状態でcookieに保存（有効期間1年）
      document.cookie = `sidemenu-collapse-status=${true}; path=/; max-age=${60 * 60 * 24 * 365}`

      //side-menu以外に触れたら閉じる
      if (!e.target.closest('#side-menu')) {
        document.body.classList.add('sidemenu-collapse');
      }
    }
  });

  $('#meal-category').on('change', '.checkbox-list input[type="checkbox"]', function() {
    if ($(this).prop('checked')) {
      $(`.${$(this).val()}`).show();
    } else {
      $(`.${$(this).val()}`).hide();
    }
  });

  $('div[class$="modal-body"]').on('click', '.accordion-open', function () {
    if($(this).nextAll('.accordion-content').is(':visible')) {
      $(this).nextAll('.accordion-content').hide()
      $(this).nextAll('.accordion-closed-content').show();
    } else {
      if ($(this).nextAll('.accordion-content').hasClass('trisection')) {
        $(this).nextAll('.accordion-content').show().css('display', 'flex');
      } else {
        $(this).nextAll('.accordion-content').show();
      }
      $(this).nextAll('.accordion-closed-content').hide();
    }
  });

  if ($('.toast-menu').find('span').text()) {
    toast_menu();
  }

  var top_scroll_btn = $('#page-top');
  top_scroll_btn.hide()
  $(window).on('scroll', function() {
    // 上に戻るボタン出現
    if($(window).scrollTop() > 100) {
      if (top_scroll_btn.is(':hidden')) {
        // [#page-top]をゆっくりフェードインする
        top_scroll_btn.fadeIn().css('display','flex');;
      }
    } else {
      if (top_scroll_btn.is(':visible')) {
        // [#page-top]をゆっくりフェードアウトする
        top_scroll_btn.fadeOut();
      }
    }
  });

  top_scroll_btn.on('click', function() {
    $('html,body').animate({scrollTop:0}, 'slow') ;
  })
});

function triggerEvent(element, event) {
  if (document.createEvent) {
      // IE以外
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true ); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
  } else {
      // IE
      var evt = document.createEventObject();
      return element.fireEvent("on"+event, evt)
  }
}